import { defineNuxtPlugin } from 'nuxt/app'

const isFirefox = navigator.userAgent.indexOf('Firefox') > -1
const isOpera = navigator.userAgent.indexOf('OPR') > -1
const userAgent = navigator.userAgent
const isSafari = navigator.userAgent.indexOf('Safari') > -1
const isIE = navigator.userAgent.indexOf('MSIE') > -1
const isEdge = navigator.userAgent.indexOf('Edge') > -1
const isChrome = navigator.userAgent.indexOf('Chrome') > -1
const isEdgeChromium = isChrome && (navigator.userAgent.indexOf('Edg') != -1)

const browsers = {
  isOpera,
  isFirefox,
  userAgent,
  isSafari,
  isIE,
  isEdge,
  isChrome,
  isEdgeChromium,
}

export default defineNuxtPlugin({
  name: 'ar-browser',
  parallel: true,
  async setup(app: any) {
    console.log('SETUP AR_BROWSER')
    app.vueApp.config.globalProperties.$arBrowser = browsers
  },
})
